import { Fragment, memo } from 'react'
import { EstimateSummaryMapConfig } from '../Summary'
import { EstimateLandSummaryMapConfig } from '../EstimateLandSummary'
import { EstimateEnergyMapConfig } from '../EstimateEnergy'
import { EstimateNoiseMapConfig } from '../EstimateNoise'
import { SunlightMapConfig } from '../Sunlight'
import { TransactionMapConfig } from '../Transaction/TransactionMap'
import { FaoMapConfig } from '../Fao/FaoMap'
import { ListingMapConfig } from '../EstimateComparables/EstimateComparablesMap'
import { LivabilityMapConfig } from '../Livability/LivabilityMap'
import { EstimateEventHistoryMapConfig } from '../EstimateEventHistory'
import { EstimateAirQualityMapConfig } from '../EstimateAirQuality'
import { EstimatePopulationMapConfig } from '../EstimatePopulation'

import { DEFAULT_MAPSTYLE } from '../../../../config'
import {
  MarketPurchaseMapConfig,
  MarketRentalMapConfig,
} from '../EstimateMarket/components/EstimateMarketMap'
import { EstimateCompanyMapConfig } from '../EstimateCompany'

const MapConfigByPage: Record<string, any> = {
  summary: EstimateSummaryMapConfig,
  parcelle: EstimateLandSummaryMapConfig,
  energy: EstimateEnergyMapConfig,
  transaction: TransactionMapConfig,
  fao: FaoMapConfig,
  listing: ListingMapConfig,
  livability: LivabilityMapConfig,
  sunlight: SunlightMapConfig,
  noise: EstimateNoiseMapConfig,
  purchase: MarketPurchaseMapConfig,
  rental: MarketRentalMapConfig,
  history: EstimateEventHistoryMapConfig,
  airQuality: EstimateAirQualityMapConfig,
  population: EstimatePopulationMapConfig,
  company: EstimateCompanyMapConfig,
}

/**
 * Map controllers have the full control of the map
 */
const MapControllers = memo((props: any) => (
  <>
    {Object.values(MapConfigByPage).map((comp, i) => {
      const { Controller } = comp

      if (!Controller) return <Fragment key={i} />

      return <Controller {...props} key={i} />
    })}
  </>
))

export interface IBuildOption extends Record<string, any> {
  value: string
  active: boolean
  title: string
  src: string
}

const buildOptions = (t: Translator, mapStyle: string, layout?: boolean) =>
  [
    {
      value: layout
        ? 'popety/cl3a7v8hy001y14pejeo2af8o'
        : 'popety/cl3jyrrml000614n6aelcet8c',
      active:
        mapStyle === 'popety/cl3jyrrml000614n6aelcet8c' ||
        mapStyle === DEFAULT_MAPSTYLE ||
        mapStyle === 'popety/cl3a7v8hy001y14pejeo2af8o',
      title: t('search.basemap.default'),
      src: '/assets/img/default_map.png',
      label: 'default',
    },
    {
      value: layout
        ? 'popety/clfi67w71001601mpthh1rl52'
        : 'popety/cl449l1ah000414umwqgcr0pd',
      active:
        mapStyle === 'popety/cl449l1ah000414umwqgcr0pd' ||
        mapStyle === 'popety/clfi67w71001601mpthh1rl52',
      title: t('search.basemap.satellite'),
      src: '/assets/img/satellite.png',
      label: 'satellite',
    },
    {
      value: 'popety/cl9mkt6w3002714rsqw7qsz7g',
      active: mapStyle === 'popety/cl9mkt6w3002714rsqw7qsz7g',
      title: t('search.basemap.ofs'),
      src: '/assets/img/OFS.png',
      style:
        mapStyle === 'popety/cl9mkt6w3002714rsqw7qsz7g'
          ? {
              boxShadow:
                '0px 2px 4px -1px #00ade6, 0px 4px 5px 0px #00ade6, 0px 1px 10px 0px #00ade6',
            }
          : { boxShadow: 'none' },
      badge: true,
      badgeTitle: 'Beta',
      label: 'ofs',
    },
  ].filter(Boolean) as Array<IBuildOption>

export { MapControllers, MapConfigByPage, buildOptions }
